let UserPointsType = {
    SET_USER_POINTS_TYPE: 'SET_USER_POINTS_TYPE',
};

export default UserPointsType;
